import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Feature, View } from 'ol';
import olMap from 'ol/Map';
import * as olProj from 'ol/proj';
import { GlobalSelectionControlService } from 'src/app/map/services/global-selection-control.service';
import { MenuManagementService } from 'src/app/menu/services/menu-management.service';
import { CoordinatePointModel } from 'src/app/models/coordinate-point';
import { FeatureType } from 'src/app/models/EnumTypes';
import { NavaidModel } from 'src/app/models/navaid';
import { ProcedureCoordinatePointModel } from 'src/app/models/procedure-coordinate-point';
import { SelectCoordinatePointsControlService } from 'src/app/popup/services/select-coordinate-points-control.service';
import { AirspaceBoundariesControlService } from 'src/app/services/airspace-boundaries-control.service';
import { MapService } from 'src/app/services/map.service';
import { ModalControlService } from 'src/app/services/modal-control.service';
import { NavaidsService } from 'src/app/services/navaids.service';
import { PointsService } from 'src/app/services/points.service';
import { ProcedureControlService } from 'src/app/services/procedure-control.service';
import { ToolsControlService } from 'src/app/services/tools-control.service';
import { SelectCoordinatePointComponent } from 'src/app/popup/select-coordinate-point/select-coordinate-point.component';
import LineString from 'ol/geom/LineString';
import { VicentyToolControlService } from 'src/app/services/vicenty-tool-control.service';
import { ProcedureLegModel } from 'src/app/models/procedure-leg';
import { cloneDeep, last } from 'lodash';
import { Validation } from 'src/app/utils/validation';
import { ProcedureModel } from 'src/app/models/procedure';
import { AirSpaceBoundaryCoordinatePointModel } from 'src/app/models/air-space-boundary-coordinate-point';
import { AirSpaceBoundaryVertexLineModel } from 'src/app/models/AirSpaceBoundaryVertexLine';
import { EventsKey } from 'ol/events';
import { TabsService } from 'src/app/services/tabsService';
import { VectorLayerDMTR } from 'src/app/menu/view-menu/layer';
import * as olExtent from 'ol/extent';
import { ProjectService } from 'src/app/services/project.service';
import { CoordinatePointsService } from 'src/app/services/coordinate-points.service';

@Component({
  selector: 'app-airspace-boundaries',
  templateUrl: './airspace-boundaries.component.html',
  styleUrls: ['./airspace-boundaries.component.scss'],
  standalone: false
})
export class AirspaceBoundariesComponent implements OnInit {

  map:olMap;
  primaryDataActive : boolean = true;
  legsDataActive : boolean = false;
  navaidsDataActive : boolean = false;
  fixPointSelectOnMapActive : boolean = false;
  startPointSelectOnMapActive : boolean = false;
  airportSelectOnMapActive : boolean = false;
  endPointSelectOnMapActive : boolean = false;
  eventKey: EventsKey

  constructor(public airspaceBoundariesService : AirspaceBoundariesControlService,
    public procedureController : ProcedureControlService,
    public globalSelectionService : GlobalSelectionControlService,
    private toolsService : ToolsControlService,
    public menuController : MenuManagementService,
    private vicentyService : VicentyToolControlService,
    private popupService : BsModalService,
    private mapService : MapService,
    public coordinatePointsController : CoordinatePointsService,
    private modalService : ModalControlService,
    private pointsService : PointsService,
    private navaidController : NavaidsService,
    public selectCoordinatePointService : SelectCoordinatePointsControlService,
    public tabsService: TabsService,
    public projectService: ProjectService) {

      this.map = this.mapService.getMap("map");
  }

  ngOnInit(): void {}


  clearLines(){
    for(var index:number = 1; index < this.selectCoordinatePointService.selectedAirSpaceBoundary.airSpaceBoundaryLines.length; index++) {
      this.deleteLineOnMap(this.selectCoordinatePointService.selectedAirSpaceBoundary.airSpaceBoundaryLines[index]);
    }
    this.selectCoordinatePointService.selectedAirSpaceBoundary.airSpaceBoundaryLines = [];
  }


  deleteCoordinatePointFromList() : void {
    let selectedCoordPoint: AirSpaceBoundaryCoordinatePointModel = new AirSpaceBoundaryCoordinatePointModel();
    this.selectCoordinatePointService.selectedAirSpaceBoundary.airSpaceBoundaryCoordinatePoints.forEach( coord => {
      if(coord.coordPoint.isselected){
        selectedCoordPoint = coord;
      }
    });

    const index = this.selectCoordinatePointService.selectedAirSpaceBoundary.airSpaceBoundaryCoordinatePoints.indexOf(selectedCoordPoint, 0);

    this.deleteLineOnMap(this.selectCoordinatePointService.selectedAirSpaceBoundary.airSpaceBoundaryLines[index]);

    let newAirSpaceCoordinatePoints: AirSpaceBoundaryCoordinatePointModel[] = cloneDeep(this.selectCoordinatePointService.selectedAirSpaceBoundary.airSpaceBoundaryCoordinatePoints);
    newAirSpaceCoordinatePoints.splice(index,1);
    this.selectCoordinatePointService.selectedAirSpaceBoundary.airSpaceBoundaryCoordinatePoints = newAirSpaceCoordinatePoints;
    this.removeCoordinatePointFromMap(selectedCoordPoint);

    if (this.selectCoordinatePointService.selectedAirSpaceBoundary.airSpaceBoundaryCoordinatePoints.length > 2 ) {
     this.airspaceBoundariesService.drawLegs();
    }
  }

  removeCoordinatePointFromMap(coordinatePoint : AirSpaceBoundaryCoordinatePointModel) : void {
    this.pointsService.getSelectedFeatures().forEach((feature) => {
      if(feature.getProperties().id == coordinatePoint.coordPoint.id){
        this.globalSelectionService.removeSelectedFeature(feature);
        this.pointsService.removeSelectedFeature(feature);
      }
    });

    this.airspaceBoundariesService.drawLegs();
  }

  getAirSpaceBoundarySelectedCoordinatePoint() : AirSpaceBoundaryCoordinatePointModel {
    let selectedCoordinatePoint : AirSpaceBoundaryCoordinatePointModel = new AirSpaceBoundaryCoordinatePointModel();

    this.selectCoordinatePointService.selectedAirSpaceBoundary.airSpaceBoundaryCoordinatePoints.forEach( coord => {
      if(coord.coordPoint.isselected){
        selectedCoordinatePoint = coord;
        return;
      }
    });
    return selectedCoordinatePoint;
  }

  changePosition(order: string) : void {
    let selectedCoordPoint = this.getAirSpaceBoundarySelectedCoordinatePoint();
    let sequenceNumberSelectedPoint = selectedCoordPoint.sequencenumber;

    let auxTable : AirSpaceBoundaryCoordinatePointModel[] = cloneDeep(this.selectCoordinatePointService.selectedAirSpaceBoundary.airSpaceBoundaryCoordinatePoints);

    if (order == 'up') {
      let index: number = this.selectCoordinatePointService.selectedAirSpaceBoundary.airSpaceBoundaryCoordinatePoints.indexOf(selectedCoordPoint, 0);
      if ((index - 1) > -1) {
        [auxTable[index - 1], auxTable[index]] = [
          auxTable[index],
          auxTable[index - 1],
        ];

      const tmpSeq = auxTable[index].sequencenumber;
      auxTable[index].sequencenumber = auxTable[index - 1].sequencenumber;
      auxTable[index - 1].sequencenumber = tmpSeq;

      this.selectCoordinatePointService.selectedAirSpaceBoundary.airSpaceBoundaryCoordinatePoints = auxTable;

      }
    }

    if (order == 'down'){
      let index: number = this.selectCoordinatePointService.selectedAirSpaceBoundary.airSpaceBoundaryCoordinatePoints.indexOf(selectedCoordPoint, 0);
      if ((index + 1) < this.selectCoordinatePointService.selectedAirSpaceBoundary.airSpaceBoundaryCoordinatePoints.length) {
       [auxTable[index], auxTable[index + 1]] = [
         auxTable[index + 1],
         auxTable[index],
       ];

      const tmpSeq = auxTable[index].sequencenumber;
      auxTable[index].sequencenumber = auxTable[index + 1].sequencenumber;
      auxTable[index + 1].sequencenumber = tmpSeq;

      this.selectCoordinatePointService.selectedAirSpaceBoundary.airSpaceBoundaryCoordinatePoints = auxTable;
      }
    }

    this.selectCoordinatePointService.selectedAirSpaceBoundary.airSpaceBoundaryLines = [];
    this.airspaceBoundariesService.deleteProcedureLegsOnMap();
    this.airspaceBoundariesService.drawLegs();
  }

  deleteLineOnMap(line : AirSpaceBoundaryVertexLineModel) : void {
    let source = this.selectCoordinatePointService.getLayerSourceFromAirSpaceBoundaryType(this.selectCoordinatePointService.selectedAirSpaceBoundary)

    source.getFeatures().forEach( feat =>{
      if(feat.getProperties().featureId == line.id && this.selectCoordinatePointService.selectedAirSpaceBoundary.uniqueid == feat.getProperties().uniqueId){
        source.removeFeature(feat);
      }
    });
  }

  addNavaidFromMap(): void {
    let features : Feature[] = this.pointsService.getSelectedFeatures().filter(feat => feat.get("featureType") == FeatureType.Navaid);
    features.forEach( feat => {
      let navaid : NavaidModel = this.pointsService.transformFeatureInNavaid(feat);
      navaid = this.navaidController.getNavaidPayload(navaid);
      const found = this.selectCoordinatePointService.selectedAirSpaceBoundary.navaids.some(el => el.id == navaid.id);
      if(!found){
        this.selectCoordinatePointService.selectedAirSpaceBoundary.navaids.push(navaid);
      }
    });
  }

  selectProcedureNavaid(navaid : NavaidModel) {
    this.selectCoordinatePointService.selectedAirSpaceBoundary.navaids.forEach( elm => {
      if(navaid.id == elm.id){
        elm.isselected = true;
      }else {
        elm.isselected = false;
      }
    });
  }

  deleteSelectedNavaidsFromList() :void {
    this.selectCoordinatePointService.selectedAirSpaceBoundary.navaids.forEach(function(item, index, object) {
      if (item.isselected) {
        object.splice(index, 1);
      }
    });
  }

  saveProcedureCoordinatePointTypeChange(event, coordPoint : ProcedureCoordinatePointModel) : void {
    coordPoint.procedurecoordpointtype = event.target.value;
  }

  saveProcedureCoordinatePointAltitudeChange(event, coordpoint : ProcedureCoordinatePointModel) : void {
    if (event.target.value >= 0 && event.target.value <= 60000){
      coordpoint.altitude = event.target.value;
    }else {
      this.modalService.showMesssageModal("Illegal Value Insertion","The Altitude value must be defined between 0 and 60000 ft.");
      event.target.value = "";
    }

  }

  async saveAirspaceBoundaries(): Promise<void> {
    if (!this.validateAirSpaceBoundaryIdentifier(this.selectCoordinatePointService.selectedAirSpaceBoundary.uniqueid || await !this.validateRequiredProcedureCoordinatePointsInformation())){
      return;
    }
    if (!this.hasMinimumVertices()) {
      this.modalService.showMesssageModal("Air Sapce Boundary Management", "Please define a minimum of three Air Space Boundary Vertices.");
      return;
    }

    if (!this.validVertecesIds()) {
      this.modalService.showMesssageModal("Air Sapce Boundary", "ID must contain only aplhanumeric characters and its lenght between 1 and 5");
      return;

    }

    if (!(await this.validateRequiredProcedureCoordinatePointsInformation())) {
      this.modalService.showMesssageModal("Air Sapce Boundary", "Please correct the information regarding new Air Space Boundary Vertice.");
      return;
    }

    this.selectCoordinatePointService.selectedAirSpaceBoundary.airSpaceBoundaryCoordinatePoints.forEach( coordPoint => {
      coordPoint.coordPoint.published = true;
    });
    this.selectCoordinatePointService.selectedAirSpaceBoundary.navaids.forEach(navaid => {
      navaid = this.navaidController.getNavaidPayload(navaid);
    })
    this.airspaceBoundariesService.saveAirSpaceBoundary(this.selectCoordinatePointService.selectedAirSpaceBoundary);
    this.selectCoordinatePointService.removeAllAirSpaceBoundarySelectedLines(this.selectCoordinatePointService.selectedAirSpaceBoundary);
    this.globalSelectionService.clearAllSelected();
    this.tabsService.closeTab(undefined,undefined,true,true);
  }

  validVertecesIds(): boolean {
    let toReturn : boolean = true;

    this.selectCoordinatePointService.selectedAirSpaceBoundary.airSpaceBoundaryCoordinatePoints.forEach( point => {
        const between1and5 = point.coordPoint.coordpointid.length > 0 && point.coordPoint.coordpointid.length < 6;
        if (!between1and5 || !Validation.isAlphaNumeric(point.coordPoint.coordpointid) ) {
          return toReturn = false;
        }
    });

    return toReturn;
  }

  hasMinimumVertices(): boolean {
    return this.selectCoordinatePointService.selectedAirSpaceBoundary.airSpaceBoundaryCoordinatePoints.length > 2 ;
  }

  async validateRequiredProcedureCoordinatePointsInformation() : Promise<boolean> {
    for (const point of this.selectCoordinatePointService.selectedAirSpaceBoundary.airSpaceBoundaryCoordinatePoints){
      if (!(await this.validateAirSpaceBoundaryCoordinatePoints(point.coordPoint, false))){
        return false;
      }
    }
    return true;
  }


  async validateAirSpaceBoundaryCoordinatePoints(newCoordPoint: CoordinatePointModel, showMessage = true) : Promise<boolean> {
    if (newCoordPoint.published){
      return true;
    }
    if (newCoordPoint.coordpointid == null || newCoordPoint.coordpointid == ""){
      return false;
    }
    if (this.selectCoordinatePointService.selectedAirSpaceBoundary.airSpaceBoundaryCoordinatePoints.filter(proc_coord => proc_coord.coordPoint.coordpointid == newCoordPoint.coordpointid).length > 1) {
      showMessage ? this.modalService.showMesssageModal("Illegal Value Insertion","ID already in use for another new Coordinate Point"): false;
      return false;
    }
    else if (this.pointsService.getAllCoordinatePointsFeaturesFromLayers().findIndex(coordPoint => coordPoint.getProperties().coordpointid == newCoordPoint.coordpointid) != -1) {
      showMessage ? this.modalService.showMesssageModal("Illegal Value Insertion","ID already in use for another Coordinate Point"): false;
      return false;
    }
    const duplicates = await this.coordinatePointsController.getCoordinaPointsDuplicates(newCoordPoint.coordpointid);
    if (duplicates) {
      showMessage ? this.modalService.showMesssageModal("Illegal Value Insertion","ID already in use for another Coordinate Point"): false;
      return false;
    }
    if (newCoordPoint.name == ''){ // dont add this verification in the first if, it is supposed to be here
      return false;
    }
    return true;
  }

  splitCriticalNavaidsFromNavaids( proc : ProcedureModel) {
    var i = proc.navaids.length
    while (i--) {
        if (proc.navaids[i].critical) {
          proc.criticalNavaids.push(proc.navaids[i]);
          proc.navaids.splice(i, 1);
        }
    }
  }

  validateAirSpaceBoundaryIdentifier(uniqueId) : boolean{
    if (uniqueId == this.selectCoordinatePointService.originalAirSpaceBoundaryID){
      return true;
    }
    if (this.pointsService.getAllAirSpaceBoundaryFeaturesFromLayers().findIndex(asb => asb.get("uniqueid") == uniqueId) != -1) {
      this.modalService.showMesssageModal("Illegal Value Insertion","Identifier already in use for another Air Space Boundary");
      //this.selectCoordinatePointService.selectedAirSpaceBoundary.uniqueid = "";
      return false
    }
    return true;

  }

  selectNavaidRows() : void{
    this.selectCoordinatePointService.selectedAirSpaceBoundary.navaids.forEach( elm => {
      if(elm.isselected){
        let feat : Feature = this.pointsService.getNavaidFeatureFromLayers(elm.id);
        let layer : VectorLayerDMTR = this.pointsService.navaidsLayers.childLayers[0].layers.find((element) => element.id === elm.navaidtype.toLowerCase()).olLayer;
        this.globalSelectionService.selectNavaidOnMap(feat, layer);
      }
    });
  }

}
